'use client'

import { config } from '@/lib/config'
import type { SiteCopy } from '@/lib/site-copy'
import { MagicCard } from '@tailark/core/magicui/magic-card'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@tailark/core/ui/accordion'
import Link from 'next/link'

export default function FAQsTwo({ translations }: { translations: SiteCopy }) {
    const t = translations

    const faqItems = t.faqs.items.map((item, index) => ({
        id: `item-${index + 1}`,
        question: item.question,
        answer: item.answer,
    }))

    return (
        <section className="py-16 md:py-24">
            <div className="mx-auto max-w-5xl px-4 md:px-6">
                <div className="mx-auto max-w-xl text-center">
                    <h2 className="text-balance text-3xl font-bold md:text-4xl lg:text-5xl">{t.faqs.title}</h2>
                    <p className="text-muted-foreground mt-4 text-balance">{t.faqs.subtitle}</p>
                </div>

                <div className="mx-auto mt-12 max-w-xl">
                    <MagicCard className='rounded-2xl' mode='gradient' gradientFrom='var(--color-primary)' gradientTo='var(--color-secondary)'>
                        <Accordion
                            type="single"
                            collapsible
                            className="card-border w-full rounded-2xl px-8 py-3 !border-3">



                            {faqItems.map((item) => (
                                <AccordionItem
                                    key={item.id}
                                    value={item.id}
                                    className="border-dashed">
                                    <AccordionTrigger className="cursor-pointer text-base hover:no-underline">{item.question}</AccordionTrigger>
                                    <AccordionContent>
                                        <p className="text-sm text-muted-foreground">{item.answer}</p>
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </MagicCard>

                    <p className="text-muted-foreground mt-6 px-8 text-center">
                        {t.faqs.contactText}{' '}
                        <Link
                            href={config.redirectUrl}
                            className="text-primary font-medium hover:underline">
                            {t.faqs.contactLink}
                        </Link>
                    </p>
                </div>
            </div>
        </section>
    )
}
